import { _ } from "libs";

export const getDefaultMessage = (type: string, params = {}): string => {
	switch (type) {
		case "challenge": {
			return _("chat.defaultMessages.challenge", null, params);
		}
	}
};
